<div class="bookings-recurring-container">

<!-- Loading spinner -->
<div *ngIf="loading" class="bookings-recurring-spinner">
  <mat-progress-spinner
    class="market-spinner"
    diameter="50"
    mode="indeterminate">
  </mat-progress-spinner>
  <p class="loading-text">
    Please wait, we’re searching for all the client's future bookings in our system...
  </p>
</div>

  <!-- Content after load -->
  <ng-container *ngIf="!loading">

    <!-- Error message -->
    <p *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </p>

    <!-- No results -->
    <div *ngIf="!errorMessage && bookings.length === 0" class="no-bookings">
      No bookings found for this recurring booking ID.
    </div>

    <!-- Results -->
    <ng-container *ngIf="bookings.length > 0">
      <h2 class="results-title">
        The following are upcoming bookings for client with ID: {{ recurringId }}
      </h2>

      <div class="bookings-list">
        <div *ngFor="let b of bookings" class="booking-item">

          <!-- Day-of-week and abbreviated month -->
            <div class="booking-date-time">
                {{ b.date | date:'EEEE (dd MMM yyyy)' }} at {{ b.time }}
            </div>

          <div>Length: {{ b.bookingLength }}</div>
          <div>Gardener: {{ b.gardener | titlecase }}</div>

        </div>
      </div>
    </ng-container>

  </ng-container>
</div>


